export const CUSTOMER_TITLES = ['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr', 'Custom']
export const CUSTOMER_GENDERS = ['Male', 'Female', 'Non-Binary', 'Questioning', 'Other', 'Prefer not to say']
export const CUSTOMER_AGE_GROUPS = ['18 to 24', '25 to 44', '45 to 64', '65 and over']
